import { EventBus } from "../components/Controls/EventBus";
import EventConstants from "../components/Controls/EventConstants";
import { AlerteDto } from "../dto/GenApi.iNotPaie.Dto/AlerteDto";
import { TypeAlerte } from "../dto/GenApi.iNotPaie.Dto/TypeAlerte";

/**
     * Action au clic selon TypeAlerte. Aligné sur ce que le backend renvoie (AlertesService) :
     * - Jamais FullNameSalarie/IdSalarie : ClotureExercice, ClotureDSN, DpaeARealiser, IncoherenceEffectif, TauxPas, NC.
     * - Toujours FullNameSalarie/IdSalarie : FinPeriodeEssais, FinPrevisionnelleCDD, RappelRenouvellementVisiteMedicale,
     *   FinValiditeCarteSejour, ValidationEntreeSalarie.
     * Return true s'il y a une redirection sinon false
     */
export function alertesActions(alerte: AlerteDto, isAdmin: boolean, isAdminPst: boolean, isPayeur: boolean, isUtilisateurPst: boolean): boolean {
    const hasSalarie = alerte.FullNameSalarie != undefined;
    const fullNameSalarie = alerte.FullNameSalarie ?? "";
    const isAdminOrPayeur = isAdmin || isAdminPst || isPayeur;

    switch (alerte.TypeAlerte) {
        case TypeAlerte.ClotureDSN:
            EventBus.NavigateTo({ path: "/dsn" });
            return true;
        case TypeAlerte.ClotureExercice:
            EventBus.$emit(EventConstants.MODAL_CLOTURE_PAIE);
            return true;
        case TypeAlerte.DpaeARealiser:
            EventBus.NavigateTo({ path: "/dpae" });
            return true;
        case TypeAlerte.IncoherenceEffectif:
            openSociete();
            return true;
        case TypeAlerte.FinPrevisionnelleCDD:
            if (!hasSalarie) return false;
            if (isAdminOrPayeur) {
                openQualification(alerte.IdSalarie, fullNameSalarie);
            } else if (isUtilisateurPst) {
                openEntree(alerte.IdSalarie, fullNameSalarie);
            } else {
                openSalarie(alerte.IdSalarie, fullNameSalarie);
            }
            return true;
        case TypeAlerte.FinValiditeCarteSejour:
            if (!hasSalarie) return false;
            if (isUtilisateurPst) {
                openDeclaration(alerte.IdSalarie, fullNameSalarie);
            } else {
                openSalarie(alerte.IdSalarie, fullNameSalarie);
            }
            return true;
        case TypeAlerte.FinPeriodeEssais:
            if (!hasSalarie) return false;
            openSalarie(alerte.IdSalarie, fullNameSalarie);
            return true;
        case TypeAlerte.ValidationEntreeSalarie:
        case TypeAlerte.RappelRenouvellementVisiteMedicale:
            if (!hasSalarie) return false;
            if (isUtilisateurPst) {
                openEntree(alerte.IdSalarie, fullNameSalarie);
            } else {
                openSalarie(alerte.IdSalarie, fullNameSalarie);
            }
            return true;
        default:
            return false;
    }
}

export function isClickableAlerte(alerte: AlerteDto): boolean {
    if (alerte.FullNameSalarie == undefined) {
        switch (alerte.TypeAlerte) {
            case TypeAlerte.ClotureExercice:
            case TypeAlerte.DpaeARealiser:
            case TypeAlerte.IncoherenceEffectif:
            case TypeAlerte.ClotureDSN:
                return true;
                break;
        }
    } else {
        return true;
    }

    return false;
}

export function openSalarie(idSalarie: number, libelle: string): void {
    EventBus.NavigateTo({
        path: "/ficheSalarie/" + idSalarie,
        query: { titre: libelle }
    });
}

export function openEntree(id: number, libelle: string): void {
    EventBus.NavigateTo({
        path: "/entreeSalarie/" + id,
        query: { titre: libelle }
    });
}

export function openQualification(idSalarie: number, libelle: string): void {
    EventBus.NavigateTo({
        path: "/ficheSalarie/" + idSalarie,
        query: { titre: libelle, onglet: "4" }
    });
}

export function openDeclaration(idSalarie: number, libelle: string): void {
    EventBus.NavigateTo({
        path: "/ficheSalarie/" + idSalarie,
        query: { titre: libelle, onglet: "2" }
    });
}

export function openSociete(): void {
    EventBus.NavigateTo({
        path: "/societe",
        query: { onglet: "1" }
    });
}



// WEBPACK FOOTER //
// ./src/Helper/alertesHelper.ts